import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL } from '../data/content';
const trustItems = ['Compra protegida.', 'Pago único.', 'Sin suscripción.', 'Acceso digital inmediato.', 'Soporte ante inconvenientes de acceso.'];
export function Guarantee() {
  return <section className="w-full bg-lavender px-5 py-12 sm:py-20" data-id="element-135" data-mp="19eqy7k1vo9n9">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-aura/25 bg-card p-8 text-center sm:p-12" data-id="element-136" data-mp="19f0ol8qu4ith">
        <span className="flex h-24 w-24 flex-col items-center justify-center rounded-full border-2 border-gold/60 bg-aura text-white" aria-hidden="true" data-id="element-137" data-mp="qnpwio9di000">
          <span className="font-serif-display text-2xl font-bold leading-none" data-id="element-138" data-mp="ozrosczy2i0v">7</span>
          <span className="mt-1 text-[9px] font-bold leading-tight tracking-[0.12em]" data-id="element-139" data-mp="tymii9zg9qzr">
            DÍAS DE
            <br data-id="element-140" data-mp="ypbcpx2il22l" />
            GARANTÍA
          </span>
        </span>

        <span className="mt-6 inline-block rounded-full border border-gold/50 bg-lavender/70 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-plum" data-id="element-141" data-mp="yrfn8xux4zbu">
          Tu compra está protegida
        </span>

        <h2 className="mt-4 font-serif-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-142" data-mp="azqp30vf1gmz">
          Probá Aura Viva 2026 durante 7 días
        </h2>

        <div className="mt-6 space-y-4 text-sm leading-relaxed text-plum/80 sm:text-base" data-id="element-143" data-mp="f0kclt4y4tfc">
          <p data-id="element-144" data-mp="k1hs1xykn9d5">
            Queremos que puedas recorrer el material con tranquilidad y comprobar si su enfoque
            conecta con lo que estás buscando.
          </p>
          <p data-id="element-145" data-mp="1vfbv9ecaimbg">
            Por eso, tu compra cuenta con una garantía de 7 días a partir de la fecha de
            adquisición.
          </p>
          <p data-id="element-146" data-mp="3rhfcerq7kk4t">
            Durante ese período podés abrir la guía, conocer los recursos y comenzar a explorar la
            experiencia de Aura Viva 2026.
          </p>
          <p data-id="element-147" data-mp="5bs3jkl5y69a">
            Si considerás que el producto no es para vos, podés comunicarte con nuestro equipo
            dentro del plazo establecido para solicitar la aplicación de la garantía.
          </p>
        </div>

        <p className="mt-7 font-serif-display text-lg font-bold leading-snug text-plum sm:text-xl" data-id="element-148" data-mp="38t0km282h22y">
          Tenés 7 días para conocer el material y{' '}
          <span className="text-aura" data-id="element-149" data-mp="3ihs6bsmjaq5f">tomar tu decisión con tranquilidad</span>.
        </p>

        <ul className="mt-7 grid w-full gap-3 text-left sm:grid-cols-2" data-id="element-150" data-mp="3drbugcyd3cl6">
          {trustItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-151" data-mp="2q1hehmiqx7wp">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold" data-id="element-152" data-mp="2pzo7u784unop">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-153" data-mp="10kvprvdzntil" />
              </span>
              <span className="text-sm leading-relaxed text-plum/80" data-id="element-154" data-mp="15bc37fht7f4y">{item}</span>
            </li>)}
        </ul>

        <div className="mt-8 w-full max-w-md" data-id="element-155" data-mp="rkgz0gi99m7p">
          <CTAButton label="QUIERO ACCEDER CON GARANTÍA" href={CHECKOUT_URL} textClassName="text-[13px] tracking-tight sm:text-[16px] sm:tracking-normal" data-id="element-156" data-mp="rls20e3vmpxr" />
          <p className="mt-3 text-xs leading-relaxed text-plum/70 sm:text-sm" data-id="element-157" data-mp="1j90nom7ysk9h">
            Acceso inmediato · Garantía de 7 días · Pago único de USD 12
          </p>
        </div>
      </motion.div>
    </section>;
}